'use client'

import * as SeparatorPrimitive from '@radix-ui/react-separator'
import * as React from 'react'
import { cn } from '#app/shared/lib/misc.js'

type SeparatorProps = {
	asChild?: boolean
	orientation?: 'horizontal' | 'vertical'
	decorative?: boolean
	textAlign?: 'left' | 'right'
	className?: string
	ref?: any
	children?: any
}

const Separator = React.forwardRef(
	(
		{
			children,
			textAlign = 'left',
			className,
			orientation = 'horizontal',
			decorative = true,
			...props
		}: SeparatorProps,
		ref,
	) =>
		children ? (
			<div className={`flex items-center gap-6 whitespace-nowrap`}>
				{textAlign === 'left' && children}
				<SeparatorPrimitive.Root
					ref={ref}
					decorative={decorative}
					orientation={orientation}
					className={cn(
						'bg-border',
						orientation === 'horizontal' ? 'h-px w-full' : 'h-full w-px',
						className,
					)}
					{...props}
				/>
				{textAlign === 'right' && children}
			</div>
		) : (
			<SeparatorPrimitive.Root
				ref={ref}
				decorative={decorative}
				orientation={orientation}
				className={cn(
					'bg-gray-200',
					orientation === 'horizontal' ? 'h-px w-full' : 'h-auto w-px',
					className,
				)}
				{...props}
			/>
		),
)
Separator.displayName = SeparatorPrimitive.Root.displayName

export { Separator }
